import React from 'react';
import { Icon, Image, Link, Text } from '@goodfynd/react-web.lib.ui';

import strings from '../../config/strings';
import { mapsUtil } from '../../utils';

import {
  StyledContainer,
  StyledMapContainer,
  StyledMapContainerMobile,
} from './styles';
import type { NextEventInfoProps } from './types';
export default function NextEventInfo({
  children,
  location,
  subTitle,
  title,
  ...props
}: NextEventInfoProps) {
  const directions = props.directions || location?.directions || '';
  return (
    <StyledContainer {...props}>
      <div>
        {location && !!subTitle && <Text as="body2">{subTitle}</Text>}
        <Text as="heading5">
          {location ? title : strings.titles.noUpcomingEvents}
        </Text>
      </div>

      {location && (
        <>
          <StyledMapContainerMobile>
            <Link href={directions} target="_blank">
              <Image
                alt={`Map of ${location.name}`}
                height={278}
                width={900}
                src={mapsUtil.getStaticMapImage(
                  location.coordinates,
                  '900x278',
                  'roadmap'
                )}
              />
            </Link>
          </StyledMapContainerMobile>

          <Link href={directions} target="_blank">
            <Icon
              name="location_pin"
              label={
                <div>
                  <Text as="body1">{location.name}</Text>

                  <Text inherit>{location.address}</Text>
                </div>
              }
            />
          </Link>
        </>
      )}

      {children}

      {location && (
        <StyledMapContainer>
          <Link href={directions} target="_blank">
            <Image
              alt={`Map of ${location.name}`}
              height={278}
              width={600}
              src={mapsUtil.getStaticMapImage(
                location.coordinates,
                '600x278',
                'roadmap'
              )}
            />
          </Link>
        </StyledMapContainer>
      )}
    </StyledContainer>
  );
}
